import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TaiKhoanService } from './tai-khoan.service';
import { Router } from '@angular/router';
import { TaiKhoan } from './tai-khoan';
import { AuthService } from '../services/auth.service';
import { NhanVien } from '../he-thong/nhan-vien/nhan-vien';
import { NhanVienService } from '../he-thong/nhan-vien/nhan-vien.service';
import { DMSanPhamService } from '../sanpham/dm-san-pham/dm-san-pham.service';
import { Config } from '../../config/config';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
var FileSaver = require('file-saver');
declare var jQuery: any;
declare var $: any;

@Component({

    selector: 'vnpt-tai-khoan',
    templateUrl: 'tai-khoan.component.html',
    providers: [TaiKhoanService, NhanVienService, DMSanPhamService]

})
export class TaiKhoanComponent implements OnInit {
    taikhoan: TaiKhoan;
    detailItem: NhanVien;
    saveStatusMessage: string = "";
    saveStatus: boolean = true;
    clientLink: string = "";
    ngaySinh: any;
    pattern = /^(09([0-9]{8}))$|^(01([0-9]{9}))$|^(08([0-9]{8}))$/;
    emailPattern = /^[a-z]+[a-z0-9._]+@[a-z.]+\.[a-z.]{2,5}$/;
    @ViewChild('myForm') myForm;
    fileList: any;
    DanhSachSP: any[] = [];

    success: boolean = false;
    error: boolean = false;
    status: boolean = false;
    successMessage: string = "";
    errorMessage: string = "";
    statusMessage: string = "";    

    fileChange(event) {
        this.fileList = event.target.files;
        this.readFiles(this.fileList);
    }
    readFile(file, reader, callback) {
        // Set a callback funtion to fire after the file is fully loaded
        reader.onload = () => {
            // callback with the results
            callback(reader.result);
        }

        // Read the file
        reader.readAsDataURL(file);
    }

    readFiles(files, index = 0) {
        // Create the file reader
        let reader = new FileReader();
        // Start reading this file
        this.readFile(files[index], reader, (result) => {
            // After the callback fires do:
            this.clientLink = result;
        });
    }

    username: string = this.auth.user.TaiKhoan;
    getUserDetails() {
        this.ShowAlert("Đang lấy thông tin tài khoản...", "status");
        this.service.GetUserDetails()
            .subscribe(
            (data) => {
                this.HideAlert("status");
                this.taikhoan = data;
                if (this.taikhoan.Avatar == undefined || this.taikhoan.Avatar.length == 0)
                    this.taikhoan.Avatar = Config.url + "User/default.png";
                else
                    this.taikhoan.Avatar = Config.url + "User/" + this.taikhoan.Avatar;
                console.log("call details");
                this.getDetails();
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }
    getDetails() {
        this.nhanVienService.GetItem(this.taikhoan.Ids)
            .subscribe(
            (data) => {
                console.log(data[0]);
                this.detailItem = data[0];
                this.ngaySinh = this.detailItem.NgaySinh;
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
        });
    }
    Save() {

        console.log(this.detailItem);
        if (this.myForm.valid == true) {
            this.ShowAlert("Đang lưu...", "status");
            this.detailItem.NgaySinh = this.ngaySinh;
            if (this.fileList == undefined || this.fileList.length == 0) {
                console.log(this.detailItem);
                
                this.nhanVienService.SaveNoAvatar(this.detailItem)
                    .subscribe((resp) => {
                        if (resp.Success) {
                            this.saveStatus = true;
                            this.getUserDetails();
                            this.HideAlert("status", true);
                            this.ShowAlert("Đã lưu thông tin thành công !", "success");
                        }
                        else {
                            this.ShowAlert("Lưu thông tin chưa thành công! Xin vui lòng kiểm tra lại", "error");
                            this.saveStatus = true;
                        }
                    },
                    (er) => {
                        if (er.status == 401) {
                            this.router.navigate(['./login']);
                        }                        
                        this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                        this.saveStatus = true;
                    });

            } else {
                this.nhanVienService.Update(this.fileList, this.detailItem)
                    .subscribe((resp) => {
                        if (resp.Success) {
                            this.getUserDetails();
                            this.saveStatusMessage = "Lưu thành công!";
                            this.saveStatus = true;
                        }
                        else {      
                            this.status=false;                            
                            this.ShowAlert("Cảnh báo! Vui lòng Avartar theo định dạng ảnh", "error");                        
                        }
                    },
                    (er) => {
                        if (er.status == 401) {
                            this.router.navigate(['./login']);
                        }
                        console.log(er);
                        this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                        this.saveStatus = false;
                    });

            }

        }// End if check submit true
        else {
            console.log("chua luu");
        }
    }
    Reset() {
        this.taikhoan = new TaiKhoan();
        this.detailItem = new NhanVien();
        this.detailItem.IdTinhThanh = 0;
        this.fileList = [];
        this.clientLink = "";
    }
    ngOnInit() {
        this.titleService.setTitle('Quản lý chức vụ');
        this.Reset();
        this.getUserDetails();
        //this.Load_DanhSachSanPham();
        $(function () {
            $('.datetimepicker').datetimepicker({ format: 'DD/MM/YYYY' });

        });
    }
    selectAll(value) {
        this.DanhSachSP.forEach((item, index) => {
            if (!item.TrangThaiXuLy)
                item.Chon = value;
        });
    }
    selectInput(item_input, event) {
        this.DanhSachSP.forEach((item, index) => {
            if (item.Id == item_input) {
                item.Chon = event;
                var reg = new RegExp(item.sort);

            }
        });
    }
    Load_DanhSachSanPham() {
        this.serviceDMSP.DanhSach_SanPham_User().subscribe(
            resp => {
                this.DanhSachSP = resp;
            });
    }
    nbsp(number) {
        let nb = "";
        number = number * 2;
        for (let i = 0; i < number; i++) {
            nb += "&nbsp;&nbsp;"
        }
        return nb
    }
    Tao_SanPhamUser() {
        let listDaiBieu = [];
        this.DanhSachSP.forEach((item, index) => {
            if (item['Chon'] == true)
                listDaiBieu.push(item['Id']);
        });
        this.serviceDMSP.addUser(listDaiBieu)
            .subscribe((data) => {
                listDaiBieu.length = 0;
                $("#myModal").modal("hide");
            },
            error => {
            });
        console.log(listDaiBieu);

    }
    ShowAlert(message: string, option: string, pop: boolean = false)
    {
        if(pop) {
            
        }
        else {            
            if (option == "success") {
                this.successMessage = message;
                this.success = true;                
                setTimeout(() => this.success = false, 3000);
            }
            else if (option == "error") {
                this.errorMessage = message;
                this.error = true;                
                setTimeout(() => this.error = false, 3000);
            }
            else {
                this.statusMessage = message;
                this.status = true;
            }
        }
    }
    HideAlert(option: string, pop: boolean = false)
    {
        if(pop) {
            
        }
        else {
            if (option == "success")
                this.success = false;
            else if (option == "error")
                this.error = false;            
            else
                setTimeout(() => this.status = false, 1000);            
        }        
    }

    constructor(
        private service: TaiKhoanService,
        private nhanVienService: NhanVienService,
        private serviceDMSP: DMSanPhamService,
        public auth: AuthService,
        private router: Router,
        private titleService: Title) {

    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/thong-tin-tai-khoan/tai-khoan.component.ts